// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingNew_loadingContainer__Od0Ge","animationContainer":"LoadingNew_animationContainer__FSvbk","animation":"LoadingNew_animation__ZKhEp"};